import { IMappers } from '../../../../repositories/billing-tariffs/v1/get-publish-terms-info';
import { DEFAULT_RESPONSE } from '../constants';
import { IPublishTermsInfo } from '../types';

export const mappers: IMappers<IPublishTermsInfo, IPublishTermsInfo> = {
  200: ({ isNewPublishTerms }) => ({ isNewPublishTerms }),
  400: () => DEFAULT_RESPONSE,
};
